import React, { useEffect } from "react";
import BannerSlider from "../components/BannerSlider";
import ProgramCard from "../components/ProgramCard";
import AboutSection from "../components/AboutSection";
import StatsSection from "../components/StatsSection";


import VideosSection from "../components/VideosSection";
import PlatformsSection from "../components/PlatformsSection";


//  Imágenes locales
import construccionImg from "../assets/images/programas_estudio/arquitectura.jpg";
import contabilidadImg from "../assets/images/programas_estudio/contabilidad.jpg";
import desarrolloImg from "../assets/images/programas_estudio/enfermeria.jpg";
import electricidadImg from "../assets/images/programas_estudio/mecatronica.jpg";
import electronicaImg from "../assets/images/programas_estudio/farmacia.jpg";


function Home() {

    useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTimeout(() => {
        const target = document.getElementById(hash);
        if (target) {
          window.scrollTo({
            top: target.offsetTop - 100, 
            behavior: "smooth",
          });
        }
      }, 400);
    }
  }, []);
  
  return (
    <>

      <BannerSlider/>
      <AboutSection />
      <section id="programas" className="programs-section">
        <div className="container my-5">
          <h2 className="text-center mb-4 text-uppercase fw-bold text-primary">
            Programas de Estudio
          </h2>
          <div className="row justify-content-center">
            <ProgramCard
              title="ARQUITECTURA DE PLATAFORMAS Y STI"
              img={construccionImg}
             // description="Forma profesionales técnicos en planificación, ejecución y control de obras civiles."
            />
            <ProgramCard
              title="CONTABILIDAD"
              img={contabilidadImg}
             // description="Capacita en análisis financiero, gestión contable y tributaria."
            />
            <ProgramCard
              title="ENFERMERÍA TÉCNICA"
              img={desarrolloImg}
              //description="Especialistas en diseño, programación y mantenimiento de software empresarial."
            />
            <ProgramCard
              title="MECATRÓNICA AUTOMOTRIZ"
              img={electricidadImg}
             // description="Prepara técnicos para el mantenimiento e instalación de sistemas eléctricos industriales."
            />
            <ProgramCard
              title="FARMACIA TÉCNICA"
              img={electronicaImg}
              //description="Desarrolla habilidades en control electrónico, automatización y mantenimiento de equipos."
            />
            
          </div>
        </div>
      </section>
      
      <StatsSection />      
      {/*
      <div id="eventos">
      <NewsSection/>
      </div>
      <VideosSection/>*/}
      <PlatformsSection/>
    </>
  );
}

export default Home;
